<pagare [pagare]="currentPagare" [plantillaHtml]="plantillaHtml" *ngIf="plantillaHtml"></pagare>

<mat-paginator class="flex justify-end text-primary print:hidden" [length]="length" [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions" (page)="changePage($event)" showFirstLastButtons hidePageSize="true">
</mat-paginator>
<!-- 
<div *ngIf="pageEvent">
  <h5>Page Change Event Properties</h5>
  <div>List length: {{pageEvent.length}}</div>
  <div>Page size: {{pageEvent.pageSize}}</div>
  <div>Page index: {{pageEvent.pageIndex}}</div>
</div> -->